import styled from 'styled-components';
import { Flexbox, ThemeButton } from '@ibinder/ui-common-core';
import {
  FormTypeValueEnum,
  IssueTemplate,
  MetadataTypeEnum,
  Workflow
} from '@ibinder/ui-common-models';
export interface FormData {
  workFlow: Workflow;
  issueTemplate?: IssueTemplate;
}

export const getStandardIssueTemplate = (name: string, labels?: any) => {
  return {
    name: name,
    items: [
      {
        itemMetadata: {
          id: "GLOBAL_Issue_Title",
          name: labels?.title ?? "Title",
          type: "text"
        },
        formType: {
          value: "TextForm",
          formLabel: labels?.description ?? "Title for issue",
          multiple: false
        },
        required: true
      },
      {
        itemMetadata: {
          id: "GLOBAL_Issue_Description",
          name: labels?.description ?? "Description",
          type: "text"
        },
        formType: {
          value: "TextForm",
          formLabel:
            labels?.workflowDescriptionFormLabel ?? "Description for issue",
          multiple: false
        },
        required: true
      }
    ],
    flags: ["Problem", "Series"]
  };
};
export const getStandardWorkflowTemplate = (
  issueTemplateId: string,
  name: string,
  labels?: any
) => {
  return {
    name,
    issueTemplateId,
    metadata: [],
    instructions: "",
    stateSettings: {
      startState: 1,
      endState: 2,
      states: [
        {
          name: "Start",
          state: 1,
          canTransitionTo: []
        },
        {
          name: "End",
          state: 2,
          canTransitionTo: []
        }
      ]
    },
    filterOptions: [
      {
        filter: "Assignee"
      },
      {
        filter: "Category"
      },
      {
        filter: "FreeText"
      },
      {
        filter: "State"
      },
      {
        filter: "Removed"
      }
    ],
    contentGroupSettings: {
      contentGroupTypeEnum: "UserDefined",
      contentGroup: "GLOBAL_IssuesUserDefined"
    },
    tenantSpecific: false,
    market: ""
  };
};
export enum ColumnEnum {
  name = 'name',
  tenantSpecific = 'tenantSpecific',
  isVisible = 'isVisible',
  created = 'created',
  createdBy = 'createdBy',
  updated = 'updated',
  lastUpdatedBy = 'lastUpdatedBy',
  market = 'market',
}

export const LayoutBinderInformationFlex = styled(Flexbox)`
  flex: 0 0 auto;
  @media (max-width: ${(p) => p.theme.devices.sm}px) {
    flex-direction: column;
  }
  margin: 0 -1rem;
  padding: 0 1rem;
`;
interface CellWrapperProps {
  clickable?: boolean;
}
export const CellWrapper = styled(Flexbox)<CellWrapperProps>`
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.1rem;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;


export enum ModeType {
  Edit = 'Edit',
  Duplicate = 'Duplicate'
}

export const ScrollableContent = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const ModalContainer = styled.div`
  padding-top: ${({ theme }) => theme.themeComponents.commonStyling.spacing.xl};
  padding-bottom: ${({ theme }) =>
    theme.themeComponents.commonStyling.spacing.xl};
  padding-left: ${({ theme }) =>
    theme.themeComponents.commonStyling.spacing.xxl};
  padding-right: ${({ theme }) =>
    theme.themeComponents.commonStyling.spacing.xxl};
`;

export const DuplicateThemeButton = styled(ThemeButton)`
  margin-right: 1rem;
`;

export const CLONE_WORKFLOW_TEMPLATE = 'cloneWorkflowTemplate';


 // Define tab type workflow names
  export const TAB_TYPE_WORKFLOWS = [
    'DefaultDocumentListWorkflow',
    'DefaultInspection',
    'DefaultMaintenance'
  ];

export const GROUP_TYPES ={
  TabTypes: 'Tab types',
  Workflows: 'Workflows'
}